<template>
	<section class="mall-image-data">
		<div class="breadcrumb_content">
			<div class="Bread_crumbs flex-align-items p-15">
				{{ $t('ScientificData.CurrentPosition') }}：
				<div>
					<span style="cursor: pointer" @click="routeFunc('home')">{{ $t('ScientificData.HomePage') }} / </span>
					<span style="cursor: pointer" @click="routeFunc('/mall/MarsDATA')">{{ $t('ScientificData.ScientificData') }} / </span>
					<span> {{ $t('ScientificData.Moon') }}</span>
				</div>
			</div>
		</div>

		<div class="mallBody">
			<div class="malltab">
				<div class="malltab_item" :class="datacheck == i ? 'check_item' : ''" v-for="(item, i) in dataList" :key="i" @click="mallclick(i)">
					{{ language == 'en' ? item.enName : item.name }}
				</div>
				<div class="renBtn" @click="sienceTreeDataFunc()" v-if="!searchShow">
					<i class="el-icon-s-grid" style="color: #15418c"></i>
					{{ $t('ScientificData.ScientificDataTree') }}
				</div>
				<div class="renBtn" v-else @click="searchShow = false">
					<i class="el-icon-back"></i>
					{{ $t('ScientificData.ReturnHomePage') }}
				</div>
			</div>

			<div class="mallfilke" v-if="!searchShow">
				<div class="mallfilke_line"></div>
				<div class="mallfilke_tab">
					<div class="mallfilke_tabItem" :class="filkeListCkeck == i ? 'mallfilke_tabItemCheck' : ''" v-for="(item, i) in filkeList" :key="i" @click="mallfilkeClick(i)">
						{{ item.name }}
					</div>
				</div>
			</div>

			<div class="dirFrame" v-if="!searchShow">
				<!--  数据目录-->
				<div v-if="filkeListCkeck == 0" class="dataMl">
					<div v-show="catalogueList.length > 0" v-for="(item, i) in catalogueList" :key="i" class="dataItem">
						<div class="item_img">
							<img class="item_img" style="height: 230px" :src="imgServeUrl + item.image" alt="" />
						</div>
						<div class="item_label">
							<div class="item_title" @click="dataSearch(item)">
								<div class="_title" :title="item.name">{{ item.name }}</div>
							</div>
							<div class="line"></div>
							<div class="item_desc">
								{{ item.desc }}
							</div>
							<div class="item_Cz">
								<div style="width: 92%">
									<div class="item_CzSl">
										<div class="CzSl_list">
											<div class="CzSl_listLabel">{{ $t('DetailMoon.startDate') }}：</div>
											<div class="CzSl_listtext">{{ item.obtainTime }}</div>
										</div>
										<div class="CzSl_list">
											<div class="CzSl_listLabel">{{ $t('DetailMoon.endDate') }}：</div>
											<div class="CzSl_listtext">{{ item.firstTime }}</div>
										</div>
										<div class="CzSl_list">
											<div class="CzSl_listLabel">{{ $t('DetailMoon.genDate') }}：</div>
											<div class="CzSl_listtext">{{ item.releaseTime }}</div>
										</div>
										<div class="CzSl_list">
											<div class="CzSl_listLabel">{{ $t('DetailMoon.releaseTime') }}：</div>
											<div class="CzSl_listtext">{{ item.releaseTime }}</div>
										</div>
										<div class="CzSl_list" style="width: 100%">
											<div class="CzSl_listLabel">{{ $t('DetailMoon.producer') }}：</div>
											<div class="CzSl_listtext">{{ item.dataProducer }}</div>
										</div>
									</div>

									<div class="item_CzSl">
										<div class="CzSl_list" style="width: 100%" v-for="(doisItem, index) in item.dois" :key="index" v-if="item.dois.length > 0">
											<!-- <div class="CzSl_listLabel">{{ doisItem.title != null && doisItem.title != doisItem.url ? doisItem.title : 'DOI' }}</div> -->
											<div class="CzSl_listtext" @click="doiChange(doisItem)" v-if="doisItem.title != null"><span style="color: #666666">DOI：</span>{{ doisItem.title }}</div>
										</div>
									</div>
									<div class="item_CzSl" v-if="item.suggestedCitation != null && item.suggestedCitation != ''">
										<div class="CzSl_list" style="width: 100%">
											<div class="CzSl_listLabel">Suggested Citation</div>
											<div class="CzSl_listtext">{{ item.suggestedCitation }}</div>
										</div>
									</div>
								</div>
								<div class="item_CzBtn" v-if="item.dataStatus == 2 && item.dataObtainStatus != 1" @click="datafanWen(item)" style="background-color: #ccc; background-image: unset">
									{{ item.dataObtainStatus == -1 || 'null' ? $t('DetailMoon.applyDownload') : $t('DetailMoon.pendingReview') }}
								</div>
								<div class="item_CzBtn" v-else @click="dataSearch(item)">{{ $t('ScientificData.DataAceess.DataAcquisition') }}</div>
							</div>
						</div>
					</div>
					<div v-if="catalogueList.length == 0">{{ $t('ScientificData.DataAceess.NoDataAvailable') }}</div>

					<div class="foot" v-if="catalogueList.length > 0">
						>
						<div class="pagediv">
							<el-pagination
								@size-change="handleSizeChangeList"
								@current-change="handleCurrentChangeList"
								:current-page="currentPageList"
								:page-sizes="[10, 20, 30]"
								:page-size="10"
								layout="total, sizes, prev, pager, next, jumper"
								:total="catalogueListTotal"
							>
							</el-pagination>
							<el-button size="mini" @click="goPageList()">Go</el-button>
						</div>
					</div>
				</div>
				<!--  科学数据-->
				<fileDataMoon v-if="filkeListCkeck == 6"></fileDataMoon>
				<!--  任务介绍-->
				<div v-if="filkeListCkeck == 1" class="dataOrder">
					<div
						v-if="dataTaskDesc.length > 0 && dataTaskDesc[0] && dataTaskDesc[0].content"
						v-html="dataTaskDescHtmlStyle"
						style="border-bottom: 1px solid #efb277; padding-bottom: 30px; text-indent: 2em; color: #555; font-size: 14px; line-height: 26px"
					></div>
					<div v-else>{{ $t('ScientificData.DataAceess.NoDataAvailable') }}</div>
					<div v-show="taskDescLoadArr.length > 0" v-for="(item, index) in taskDescLoadArr" :key="index">
						<div style="height: auto; padding: 16px 0px; display: flex; overflow: hidden; border-bottom: 1px solid #eee">
							<!-- <img style="width: 160px; height: auto; margin-right: 20px" :src="`http://10.1.200.142:30802/` + item.image" /> -->
							<img style="width: 160px; height: auto; margin-right: 20px" :src="item.image" />
							<div style="width: 90%">
								<span style="font-weight: 600; color: #222222; font-size: 18px; margin-bottom: 10px">{{ item.title }}</span>
								<div v-html="item.content" style="color: #555555; font-size: 16px; line-height: 26px; margin-bottom: 10px"></div>
							</div>
						</div>
					</div>
				</div>

				<!--  数据说明-->
				<div v-if="filkeListCkeck == 2" class="dataOrder">
					<div
						v-if="dataExplain.length > 0 && dataExplain[0] && dataExplain[0].content"
						v-html="dataExplain[0].content"
						style="color: #333; font-size: 14px; line-height: 28px; margin-bottom: 10px"
					></div>
					<div v-else>{{ $t('ScientificData.DataAceess.NoDataAvailable') }}</div>
				</div>

				<!--  引用致谢-->
				<div v-if="filkeListCkeck == 3" class="dataOrder">
					<div
						v-if="dataQuteThank.length > 0 && dataQuteThank[0] && dataQuteThank[0].content"
						v-html="dataQuteThank[0].content"
						style="color: #333; font-size: 14px; line-height: 28px; margin-bottom: 10px"
					></div>
					<div v-else>{{ $t('ScientificData.DataAceess.NoDataAvailable') }}</div>
				</div>

				<!--  版权声明-->
				<div v-if="filkeListCkeck == 4" class="dataOrder">
					<div
						v-if="copyright.length > 0 && copyright[0] && copyright[0].content"
						v-html="copyright[0].content"
						style="
							color: #333;
							font-size: 14px;
							text-align: left;
							line-height: 28px;
							margin-bottom: 10px;
							display: flex;
							flex-direction: column;
							line-height: 28px;
							margin-bottom: 10px;
							align-items: baseline;
						"
					></div>
					<div v-else>{{ $t('ScientificData.DataAceess.NoDataAvailable') }}</div>
					<!-- <div class="dotMsg">● 本平台对其发布的数据产品或服务及平台上发布的相关信息的全部内容拥有版权等知识产权，受法律保护。</div>
            <div class="dotMsg">● 未经本平台书面许可，任何单位及个人不得以任何方式或理由对上述数据产品、服务、信息、材料的任何部分进行复制、修改、抄录、传播及销售。</div>
            <div class="dotMsg">● 凡侵犯本平台版权知识产权的，必依法追究其法律责任，特此郑重声明！</div> -->
				</div>
			</div>
			<div class="dirFrame" v-else>
				<!-- 检索功能 -->
				<div class="search_body">
					<div class="search_title">
						<div class="line"></div>
						{{ $t('ScientificData.DataAceess.Payload') }}
					</div>

					<div class="search_cont">
						<!-- <div class="search_item">全部</div> -->
						<div
							class="search_item"
							:class="YXZHcheck == i ? 'search_itemCheck' : ''"
							@click="checkYXZH(i)"
							v-if="dataList[datacheck] && dataList[datacheck].children.length > 0"
							v-for="(item, i) in dataList[datacheck].children"
							:key="i"
						>
							<!-- {{ item.name }} -->
							{{ language == 'en' ? item.enName : item.name }}
						</div>
					</div>

					<div class="search_title" style="margin-top: 20px">
						<div class="line"></div>
						{{ $t('ScientificData.DataAceess.DataLevel') }}
					</div>
					<div class="search_cont">
						<!-- <div class="search_item">全部</div> -->
						<div
							class="search_item"
							:class="SJJBcheck == i ? 'search_itemCheck' : ''"
							@click="checkSJJB(i)"
							v-if="dataList[datacheck] && dataList[datacheck].children.length > 0 && dataList[datacheck].children[YXZHcheck].children.length > 0"
							v-for="(item, i) in dataList[datacheck].children[YXZHcheck].children"
							:key="i"
						>
							<!-- {{ item.name }} -->
							{{ language == 'en' ? item.enName : item.name }}
						</div>
					</div>
					<div v-if="searchMore">
						<div class="search_title" style="margin-top: 20px">
							<div class="line"></div>
							{{ $t('ScientificData.DataAceess.AdvancedSearch') }}
						</div>
						<div class="search_cont2" style="display: flex; flex-wrap: wrap">
							<div style="margin-right: 20px; margin-bottom: 40px; margin-top: 0px">
								<div style="display: flex; margin-bottom: 15px">
									<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.Longitude') }}</div>
									<div style="display: flex">
										<el-input type="number" v-model="latitudeLongitude.minLong" placeholder="-180" :min="-180" :max="180" style="width: 100px"></el-input>
										<div style="line-height: 38px; margin: 0 10px">～</div>
										<el-input type="number" v-model="latitudeLongitude.maxLong" placeholder="180" :min="-180" :max="180" style="width: 100px"></el-input>
									</div>
								</div>
								<div style="display: flex">
									<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.Latitude') }}</div>
									<div style="display: flex">
										<el-input type="number" v-model="latitudeLongitude.minLat" placeholder="-90" :min="-90" :max="90" style="width: 100px"></el-input>
										<div style="line-height: 38px; margin: 0 10px">～</div>
										<el-input type="number" v-model="latitudeLongitude.maxLat" placeholder="90" :min="-90" :max="90" style="width: 100px"></el-input>
									</div>
								</div>
								<div>
									<el-button style="width: 70%; margin-top: 10px" type="primary" size="mini" @click="divByLonLatFunc()">{{
										$t('ScientificData.DataAceess.DisplayonPlanetMap')
									}}</el-button>
									<el-button style="margin-top: 10px" size="mini" @click="resetLonLatFunc()">{{ $t('ScientificData.DataAceess.Reset') }}</el-button>
								</div>
							</div>
							<div style="position: relative; width: 360px; height: 180px; border: 2px solid #000">
								<img src="../../assets/imgs/moon.jpg" alt="" style="width: 100%; height: 100%" />
								<!-- <i
									class="el-icon-view"
									title="显示"
									@click="divByLonLatFunc"
									style="position: absolute; margin-left: -22px; font-size: 18px; cursor: pointer; background-color: #fff"
								></i> -->
								<div class="divByLonLatMoon" style="position: absolute; float: left"></div>
							</div>

							<!-- <img src="../../assets/imgs/moon.jpg" alt="" style="width: 400px; height: 150px; border: 2px solid #000" /> -->
						</div>
						<div class="search_cont2" style="display: flex; flex-wrap: wrap">
							<div style="display: flex; margin-bottom: 15px">
								<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.DataName') }}</div>
								<div><el-input v-model="searchJ.name" placeholder="请输入数据名称"></el-input></div>
							</div>

							<div style="display: flex">
								<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.StartTime') }}</div>
								<div><el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchJ.startTime" type="datetime" placeholder="选择日期"> </el-date-picker></div>
							</div>

							<div style="display: flex">
								<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.EndTime') }}</div>
								<div><el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="searchJ.endTime" type="datetime" placeholder="选择日期"> </el-date-picker></div>
							</div>
							<div style="display: flex">
								<div style="line-height: 38px; margin: 0 10px">{{ $t('ScientificData.DataAceess.OrbitNumber') }}</div>
								<div style="display: flex">
									<el-input v-model="orbit.min" placeholder="0" style="width: 100px"></el-input>
									<div style="line-height: 38px; margin: 0 10px">～</div>
									<el-input v-model="orbit.max" placeholder="9999" style="width: 100px"></el-input>
								</div>
							</div>
							<div style="margin-left: 15px">
								<el-button type="primary" @click="getSearchList()">{{ $t('ScientificData.DataAceess.Search') }}</el-button>
								<!-- <el-button type="info">重置</el-button> -->
							</div>
						</div>
					</div>
					<div @click="searchMore = !searchMore" style="position: absolute; bottom: 15px; right: 15px; color: #666; cursor: pointer">
						<i :class="searchMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
						{{ searchMore ? $t('ScientificData.DataAceess.ClearSearch') : $t('ScientificData.DataAceess.ExpandMore') }}
					</div>
				</div>
				<div style="text-align: right; font-size: 25px; margin-right: 15px; margin-top: 15px; cursor: pointer">
					<i class="el-icon-s-unfold" style="margin-right: 5px; color: #15418c" :style="styleF == 1 ? 'color: #15418c;' : ''" @click="qieStyle(1)"></i>
					<i class="el-icon-s-grid" style="#15418c" :style="styleF == 2 ? 'color: #15418c' : ''" @click="qieStyle(2)"></i>
				</div>
				<div class="table_topdiv" style="justify-content: center; background-color: #fff" v-if="searchList.length == 0">
					<el-empty :description="$t('ScientificData.DataAceess.NoDataAvailable')" />
				</div>

				<div class="table_topdiv" v-else>
					<div class="select_all_control">
						<input type="checkbox" id="select-all" :checked="allSelected" @change="toggleAllSelection" />
						<label for="select-all" class="select_label">{{ $t('ScientificData.DataAceess.DataList') }}</label>
					</div>

					<div class="operator_Btn">
						<div class="item_CzBtn1" v-show="dataObtainStatus || dataStatus == 1" @click="getBatchAnnexZip()">{{ $t('ScientificData.DataAceess.BatchDownload') }}</div>
						<div class="item_CzBtn2" @click="batchAddMark()">{{ $t('ScientificData.DataAceess.BatchFavorite') }}</div>
					</div>
				</div>

				<div class="SJbody" v-loading="loading" element-loading-text="加载中" v-show="styleF == 1">
					<div v-for="(item, i) in searchList" :key="i" class="dataItem">
						<div class="item_select">
							<input type="checkbox" class="checkboxClass" :id="'item-' + item.dataInfoId" :value="item.dataInfoId" v-model="selectedItems" />
							<img class="item_img" v-if="item.image" @click="selectImg(item)" :src="imgServeUrl + item.image" alt="" />
							<img class="item_img" v-else :src="defualtImg" alt="" />
						</div>
						<div class="item_label">
							<div class="item_title">
								<div class="_title" :title="item.name">{{ item.name }}</div>
								<!-- <div class="_btn">
                  <div class="btnlist">立即下载</div>
                  <div class="btnlist">加入收藏夹</div>
                </div> -->
							</div>
							<div class="line"></div>

							<div class="item_Cz">
								<div class="item_CzSl">
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.ReceivingStation') }}：</div>
										<div class="CzSl_listtext">{{ item.receivingStation }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.StartTime') }}：</div>
										<div class="CzSl_listtext">{{ item.startTime == null ? 'undefined' : item.startTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.EndTime') }}：</div>
										<div class="CzSl_listtext">{{ item.endTime == null ? 'undefined' : item.endTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DetectionMission') }}：</div>
										<div class="CzSl_listtext">{{ item.detectionTask }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.Payload') }}：</div>
										<div class="CzSl_listtext">{{ item.loadName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DataLevel') }}：</div>
										<div class="CzSl_listtext">{{ item.dataLevelName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.Size') }}：</div>
										<div class="CzSl_listtext">{{ formatBytes(item.dataSize) }}</div>
									</div>

									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DataVersion') }}：</div>
										<div class="CzSl_listtext">{{ item.dataVersion }}</div>
									</div>
								</div>
								<div>
									<div class="item_CzBtn1" v-show="dataObtainStatus || dataStatus == 1" @click="getAnnexZip(item)">{{ $t('ScientificData.DataAceess.DownloadNow') }}</div>
									<div class="item_CzBtn2" @click="dataMark(item)">
										{{ item.bookmark ? $t('ScientificData.DataAceess.CancelFavorites') : $t('ScientificData.DataAceess.AddtoFavorites') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="SJbody bodyGird" v-show="styleF == 2">
					<div v-for="(item, i) in searchList" :key="i" class="dataItemGird">
						<div class="item_select">
							<input type="checkbox" :id="'item-' + item.dataInfoId" :value="item.dataInfoId" v-model="selectedItems" />
							<!-- <label :for="'item-' + item.id">{{ item.name }}</label> -->
						</div>
						<div class="item_img">
							<img class="item_img" v-if="item.image" :src="imgServeUrl + item.image" alt="" />
							<img class="item_img" v-else :src="defualtImg" alt="" />
						</div>
						<div class="item_label">
							<div class="item_title">
								<div class="_title" :title="item.name">{{ item.name }}</div>
							</div>

							<div class="item_Cz">
								<div class="item_CzSl">
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.ReceivingStation') }}：</div>
										<div class="CzSl_listtext">{{ item.receivingStation }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.StartTime') }}：</div>
										<div class="CzSl_listtext">{{ item.startTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.EndTime') }}：</div>
										<div class="CzSl_listtext">{{ item.endTime }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DetectionMission') }}：</div>
										<div class="CzSl_listtext">{{ item.detectionTask }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.Payload') }}：</div>
										<div class="CzSl_listtext">{{ item.loadName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DataLevel') }}：</div>
										<div class="CzSl_listtext">{{ item.dataLevelName }}</div>
									</div>
									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.Size') }}：</div>
										<div class="CzSl_listtext">{{ formatBytes(item.dataSize) }}</div>
									</div>

									<div class="CzSl_list">
										<div class="CzSl_listLabel">{{ $t('ScientificData.DataAceess.DataVersion') }}：</div>
										<div class="CzSl_listtext">{{ item.dataVersion }}</div>
									</div>
								</div>
								<div style="display: flex; margin-top: 10px; margin-left: 50px">
									<div class="item_CzBtn1" v-show="dataObtainStatus || dataStatus == 1" @click="getAnnexZip(item)">{{ $t('ScientificData.DataAceess.DownloadNow') }}</div>
									<div class="item_CzBtn2" @click="dataMark(item)">
										{{ item.bookmark ? $t('ScientificData.DataAceess.CancelFavorites') : $t('ScientificData.DataAceess.AddtoFavorites') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="foot">
					<div class="pagediv" v-if="searchList.length > 0">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="currentPage"
							:page-sizes="[10, 20, 30]"
							:page-size="10"
							layout="total, sizes, prev, pager, next, jumper"
							:total="listTotal"
						>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import axios from 'axios'
import cookie from '@/utils/cookie.js'
import fileDataMoon from './fileDataMoon.vue'

export default {
	name: 'moonDATA',
	components: { fileDataMoon },
	data() {
		return {
			language: localStorage.getItem('change-language'),
			goPageNum: 0,
			loading: false,
			defualtImg: require('./../../assets/moon.png'),
			taskDescLoadArr: [],
			imgServeUrl: window.dataManage.imgDev,
			latitudeLongitude: {
				minLat: '',
				maxLat: '',
				minLong: '',
				maxLong: ''
			},
			orbit: {
				min: '',
				max: ''
			},
			selectedItems: [],
			currentPage: 1,
			listTotal: 0,
			pageSize: 10,
			pageNum: 1,

			currentPageList: 1,
			pageSizeList: 10,
			pageNumList: 1,
			catalogueListTotal: 0,

			styleF: 1, //1列表 2 网格
			searchMore: true,
			dataList: [
				{
					name: '天问一号'
				}
			],
			dataStatus: 1,
			dataObtainStatus: true,
			datacheck: 0,
			filkeList: [],
			filkeListCkeck: 0,
			catalogueList: [],
			dataTaskDesc: [],
			dataExplain: [],
			dataQuteThank: [],
			copyright: [],
			searchShow: false,
			SJJBcheck: 0,
			YXZHcheck: 0,
			searchList: [],
			searchJ: {
				name: '',
				startTime: '',
				endTime: ''
			}
		}
	},
	mounted() {
		this.filkeList = [
			{
				name: this.$t('ScientificData.DataCatalog')
			},
			{
				name: this.$t('ScientificData.MissionIntroduction')
			},
			{
				name: this.$t('ScientificData.DataDeclaration')
			},
			{
				name: this.$t('ScientificData.ReferenceAndAcknowledgement')
			},
			{
				name: this.$t('ScientificData.CopyrightNotice')
			}
		]
		this.getdata()
	},
	watch: {
		latitudeLongitude: {
			handler(newVal, oldVal) {
				if (newVal.minLat < -90) {
					newVal.minLat = -90
				} else if (newVal.minLat > 90) {
					newVal.minLat = 90
				} else if (newVal.maxLat < -90) {
					newVal.maxLat = -90
				} else if (newVal.maxLat > 90) {
					newVal.maxLat = 90
				}
				if (newVal.minLong < -180) {
					newVal.minLong = -180
				} else if (newVal.minLong > 180) {
					newVal.minLong = 180
				} else if (newVal.maxLong > 180) {
					newVal.maxLong = 180
				} else if (newVal.maxLong < -180) {
					newVal.maxLong = -180
				}
				// if ((newVal.minLat < -90 || newVal.minLat > 90) && newVal.minLat > newVal.maxLat) {
				// 	this.nextTick(() => {
				// 		this.latitudeLongitude.minLat = oldVal.minLat
				// 	})
				// }
				// if ((newVal.maxLat < -90 || newVal.maxLat > 90) && newVal.minLat > newVal.maxLat) {
				// 	this.latitudeLongitude.maxLat = oldVal.maxLat
				// }
				// if ((newVal.minLong < -180 || newVal.minLong > 180) && newVal.minLong > newVal.maxLong) {
				// 	this.latitudeLongitude.minLong = oldVal.minLong
				// }
				// if ((newVal.maxLong < -180 || newVal.maxLong > 180) && newVal.minLong > newVal.maxLong) {
				// 	this.latitudeLongitude.maxLong = oldVal.maxLong
				// }
				// this.divByLonLatFunc()
			},
			deep: true
		}
	},
	computed: {
		allSelected() {
			return this.selectedItems.length === this.searchList.length
		}
	},
	methods: {
		doiChange(item) {
			console.log(item)
			const path = item.url.slice(1)
			window.open('/ce5web' + path, '_blank')
		},
		resetLonLatFunc() {
			this.latitudeLongitude = {
				minLat: '',
				maxLat: '',
				minLong: '',
				maxLong: ''
			}
			this.divByLonLatFunc()
		},
		formatBytes(bytes, decimals = 2) {
			if (bytes === 0) return '0 Bytes'
			const k = 1024
			const dm = decimals < 0 ? 0 : decimals
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			const i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
		},
		routeFunc(name) {
			if (name == 'home') {
				location.href = location.host // 重新加载当前页面
				location.replace(window.location.origin)
			} else {
				location.reload() // 重新加载当前页面
				location.reload(true) // 强制从服务器重新加载当前页面
			}
		},
		checkFunc() {
			if (this.latitudeLongitude.minLat > this.latitudeLongitude.maxLat) {
				this.$message.warning('最小纬度值不能大于最大纬度值！')
				return false
			}
			if (this.latitudeLongitude.minLong > this.latitudeLongitude.maxLong) {
				this.$message.warning('最小经度值不能大于最大经度值！')
				return false
			}
			return true
		},
		divByLonLatFunc() {
			if (!this.checkFunc()) {
				return
			}
			var divElements = document.getElementsByClassName('divByLonLatMoon')
			if (this.latitudeLongitude.maxLat && this.latitudeLongitude.maxLong && this.latitudeLongitude.minLat && this.latitudeLongitude.minLong) {
				for (var i = 0; i < divElements.length; i++) {
					divElements[i].style.backgroundColor = 'rgba(0, 0, 255,0.6)'
					if (this.latitudeLongitude.maxLong * 1 > 0 && this.latitudeLongitude.minLong * 1 > 0) {
						divElements[i].style.width = (this.latitudeLongitude.maxLong - this.latitudeLongitude.minLong) * 1 + 'px'
					} else if (this.latitudeLongitude.maxLong * 1 < 0 && this.latitudeLongitude.minLong * 1 < 0) {
						divElements[i].style.width = (Math.abs(this.latitudeLongitude.maxLong) - Math.abs(this.latitudeLongitude.minLong)) * 1 + 'px'
					} else {
						divElements[i].style.width = (Math.abs(this.latitudeLongitude.maxLong) + Math.abs(this.latitudeLongitude.minLong)) * 1 + 'px'
					}

					divElements[i].style.height = this.latitudeLongitude.maxLat - this.latitudeLongitude.minLat + 'px'
					divElements[i].style.left = this.latitudeLongitude.minLong * 1 + 180 + 'px'
					console.log(divElements[i].style.left)
					divElements[i].style.top = 90 - this.latitudeLongitude.maxLat + 'px'
				}
			} else {
				for (var i = 0; i < divElements.length; i++) {
					divElements[i].style.width = '0px'
					divElements[i].style.height = '0px'
					divElements[i].style.left = '0px'
					divElements[i].style.top = '0px'
				}
			}
		},
		handleSizeChange(val) {
			this.pageSize = val
			this.getSearchList()
		},
		handleCurrentChange(val) {
			// this.goPageNum = val
			this.pageNum = val
			this.getSearchList()
		},
		goPage() {
			// this.pageSize = this.goPageNum
			this.getSearchList()
		},
		// 数据列表全选
		toggleAllSelection(e) {
			if (e.target.checked) {
				this.selectedItems = this.searchList.map((item) => item.dataInfoId)
			} else {
				this.selectedItems = []
			}
		},
		async getdata(item) {
			try {
				this.dataList = []
				let res = await this.$http.get(this.$const.Platformconsulting.scienceCategoryURl)
				if (res.code === 200) {
					console.log(res)
					const resData = res.data[0]
					this.dataList = resData.children
					this.getcatalogue()
				}
			} catch (e) {
				console.log(e)
			}
		},
		datafanWen(obj) {
			const userToken = cookie.get('PIE_MALL_Token')
			if (!userToken) {
				this.$message.warning('请登录用户！')
				return
			}
			this.$http.put(this.$const.Platformconsulting.catalogueReviewApply + obj.id, '', true).then((res) => {
				if (res.code == 200) {
					this.$message({
						message: '已申请数据下载权限，可在个人中心【审核列表】查看'
					})
					this.getSearchList(obj.id)
				}
			})
		},
		dataSearch(obj) {
			this.dataStatus = obj.dataStatus //数据是 1 公开期 2 保护期 3 其他
			this.dataObtainStatus = obj.dataObtainStatus //数据申请下载权限 true 申请通过 false 不通过
			if (this.dataStatus != 1 && !this.dataObtainStatus) {
				this.$confirm('当前数据为保护期数据是否申请下载?', '提示', {
					confirmButtonText: '继续查看',
					cancelButtonText: '申请下载',
					type: 'warning'
				})
					.then(() => {
						this.searchShow = true
						this.dataList[this.datacheck].children.forEach((item, i) => {
							if (obj.load == item.id) {
								this.YXZHcheck = i
							}
							item.children.forEach((item1, j) => {
								if (obj.dataLevel == item1.id) {
									this.SJJBcheck = j
								}
							})
						})
						this.getSearchList(obj.id)
					})
					.catch(() => {
						this.$http
							.put(this.$const.Platformconsulting.catalogueReviewApply + obj.id, '', true)
							.then((res) => {
								if (res.code == '200') {
									this.$message({
										message: '已申请数据下载权限'
									})
								}
							})
							.catch((error) => {
								console.log(error, 'error')
							})
					})
			} else {
				this.searchShow = true
				this.dataList[this.datacheck].children.forEach((item, i) => {
					if (obj.load == item.id) {
						this.YXZHcheck = i
					}
					item.children.forEach((item1, j) => {
						if (obj.dataLevel == item1.id) {
							this.SJJBcheck = j
						}
					})
				})
				this.getSearchList(obj.id)
			}
		},
		async batchAddMark() {
			if (this.selectedItems.length < 1) {
				this.$message.warning('请选择需要收藏的产品数据')
				return
			}
			const userToken = cookie.get('PIE_MALL_Token')
			if (!userToken) {
				this.$message.warning('请登录用户！')
				return
			}
			try {
				let res = await this.$http.post(this.$const.Platformconsulting.batchSciencebookmarkaddURL, this.selectedItems)
				this.searchList.forEach((element) => {
					element.bookmark = true
				})
				this.$message.success('收藏成功！')
			} catch (error) {
				this.$message.error('操作失败')
			}
		},
		async dataMark(obj) {
			const userToken = cookie.get('PIE_MALL_Token')
			if (!userToken) {
				this.$message.warning('请登录用户！')
				return
			}
			if (obj.bookmark) {
				try {
					let res = await this.$http.delete(this.$const.Platformconsulting.batchSciencebookmarkdelURL, [obj.dataInfoId])
					if (res.code === 200) {
						obj.bookmark = !obj.bookmark
						this.$message.success('取消收藏成功！')
					}
				} catch (e) {
					this.$message.error('操作失败')
				}
			} else {
				try {
					let res = await this.$http.post(this.$const.Platformconsulting.batchSciencebookmarkaddURL, [obj.dataInfoId])
					this.$message.success('收藏成功！')
					if (res.code === 200) {
						obj.bookmark = !obj.bookmark
					}
				} catch (e) {
					this.$message.error('操作失败')
				}
			}
		},
		async getBatchAnnexZip() {
			if (this.selectedItems.length < 1) {
				this.$message.warning('请选择需要下载的产品数据')
				return
			}
			console.log(this.selectedItems)
			let res = ''
			res = await this.$http.post(this.$const.Platformconsulting.getBatchAnnexZip, this.selectedItems)
			this.$message.success('下载成功！')
			if (res.code === 200) {
				let res1 = await this.$http.download(this.$const.Platformconsulting.downloadURl, { fileName: res.data, delete: true })
			}
		},
		async getAnnexZip(obj, flag) {
			let paramData = ''
			if (flag) {
				paramData = obj
				// window.open(this.$const.Platformconsulting.getAnnexZipURl + obj, '_blank')
				// res = await this.$http.get(this.$const.Platformconsulting.getAnnexZipURl + obj)
			} else {
				paramData = obj.dataInfoId
				// window.open(this.$const.Platformconsulting.getAnnexZipURl + obj.dataInfoId, '_blank')
				// res = await this.$http.get(this.$const.Platformconsulting.getAnnexZipURl + obj.dataInfoId)
			}
			const authorizationVal = this.$cookie.get('PIE_MALL_Token')
			// 基础 POST 下载
			axios({
				method: 'get',
				url: `${window.dataManage.devPrefix}/client/science/dataInfo/getAnnexZip/${paramData}`,
				// data: paramData,
				headers: {
					Authorization: `Bearer ${authorizationVal}`
				}
				// responseType: 'blob' // 重要：指定响应类型为 blob
			})
				.then((response) => {
					this.$message.success('下载成功！')
					window.open(response.data.data, '_blank')
					// 创建 blob 对象
					// const blob = new Blob([response.data], { type: 'text/plain' })
					// console.log(response.data)
					// // 创建下载链接
					// const url = window.URL.createObjectURL(blob)
					// const link = document.createElement('a')
					// link.href = url
					// link.download = obj.name // 设置下载文件名
					// document.body.appendChild(link)
					// link.click()
					// // 清理
					// document.body.removeChild(link)
					// window.URL.revokeObjectURL(url)
				})
				.catch((error) => {
					console.error('下载失败:', error)
				})
		},
		// 检索数据

		async getSearchList(item) {
			this.loading = true
			var parms = {
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				category: this.dataList[this.datacheck].parentId, // 火星 id
				task: this.dataList[this.datacheck].id, //任务id 天问一号

				dataCatalogueId: item || '', //数据任务目录id

				load: this.dataList[this.datacheck].children[this.YXZHcheck].id, //载荷 id
				dataLevel: this.dataList[this.datacheck].children[this.YXZHcheck].children[this.SJJBcheck].id, //数据级别 id
				...this.searchJ,
				...this.orbit,
				minLat: this.latitudeLongitude.minLat ? this.latitudeLongitude.minLat * 1 : '',
				maxLat: this.latitudeLongitude.maxLat ? this.latitudeLongitude.maxLat * 1 : '',
				maxLong: this.latitudeLongitude.maxLong ? this.latitudeLongitude.maxLong * 1 : '',
				minLong: this.latitudeLongitude.minLong ? this.latitudeLongitude.minLong * 1 : ''
				// ...this.latitudeLongitude
			}
			let res = await this.$http.get(this.$const.Platformconsulting.dataInfoListURL, parms)

			if (res.code === 200) {
				this.loading = false
				this.searchList = res.rows
				console.log(this.searchList)
				this.listTotal = res.total
			}
		},

		handleSizeChangeList(val) {
			this.pageSizeList = val
			this.getcatalogue()
		},
		handleCurrentChangeList(val) {
			this.pageNumList = val
			// this.pageSize = val
			this.getcatalogue()
		},
		goPageList() {
			this.pageSizeList = this.goPageNum
			this.getcatalogue()
		},

		// 数据目录
		async getcatalogue(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.scienceCatalogueURl + `?pageNum=${this.pageNumList}&pageSize=${this.pageSizeList}`, {
					task: this.dataList[this.datacheck].id
				})
				if (res.code === 200) {
					this.catalogueList = res.rows
					this.catalogueListTotal = res.total
				}
			} catch (e) {
				console.log(e)
			}
		},
		// 查询任务介绍的载荷列表
		async getTaskDescLoadlist(ID) {
			let res = await this.$http.get(this.$const.Platformconsulting.taskDescLoadlist + `?taskDescId=${ID}&pageSize=1000&pageNum=1`)
			if (res.code === 200) {
				console.log(res)
				this.taskDescLoadArr = res.rows
			}
		},
		// 任务介绍
		async getdataTaskDescList(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.dataTaskDescListURl, { task: this.dataList[this.datacheck].id })
				if (res.code === 200) {
					this.dataTaskDesc = res.rows
					this.dataTaskDescHtmlStyle = res.rows[0].content
					this.getTaskDescLoadlist(res.rows[0].taskDescId)
				}
			} catch (e) {
				console.log(e)
			}
		},
		// 数据说明
		async dataExplainList(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.dataExplainListURl, { task: this.dataList[this.datacheck].id })
				if (res.code === 200) {
					this.dataExplain = res.rows
				}
			} catch (e) {
				console.log(e)
			}
		},
		// 引用致谢
		async dataQuteThankList(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.dataQuteThankListURl, { task: this.dataList[this.datacheck].id })
				if (res.code === 200) {
					this.dataQuteThank = res.rows
				}
			} catch (e) {
				console.log(e)
			}
		},
		// 关于我们
		async copyrightList(item) {
			try {
				let res = await this.$http.get(this.$const.Platformconsulting.copyrightListURL, { task: this.dataList[this.datacheck].id })
				if (res.code === 200) {
					this.copyright = res.rows
				}
			} catch (e) {
				console.log(e)
			}
		},

		checkSJJB(i) {
			this.SJJBcheck = i
			this.getSearchList()
		},
		checkYXZH(i) {
			this.YXZHcheck = i
			this.SJJBcheck = 0
			this.getSearchList()
		},
		qieStyle(e) {
			this.styleF = e
		},
		mallclick(i) {
			this.YXZHcheck = 0
			this.SJJBcheck = 0
			this.datacheck = i
			this.getSearchList()
			this.mallfilkeClick(0)
		},
		sienceTreeDataFunc() {
			this.filkeListCkeck = 6
		},
		mallfilkeClick(i) {
			this.filkeListCkeck = i
			switch (this.filkeListCkeck) {
				case 0:
					this.getcatalogue()
					break
				case 1:
					this.getdataTaskDescList()
					break
				case 2:
					this.dataExplainList()
					break
				case 3:
					this.dataQuteThankList()
					break
				case 4:
					this.copyrightList()
					break

				default:
					break
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.mall-image-data {
	width: 100%;
	margin: 0 auto;
	.bannerBG {
		width: 100%;
		height: 250px;
		background-image: url('../../assets/imgs/RemoteSensingMall/bg1.png');
		background-repeat: no-repeat;
		background-size: cover;
	}
	.bannerTitle {
		width: 80%;
		margin: 0 auto;
		padding-top: 3%;
		line-height: 60px;
		font-size: 28px;
		color: #f5f5f5;
	}
	.bannerzn {
		width: 80%;
		margin: 0 auto;
		line-height: 40px;
		font-size: 22px;
		color: #f5f5f5;
	}
	.breadcrumb_content {
		width: 80%;
		margin: 0 auto;
	}
	.mallBody {
		width: 80%;
		margin: 0 auto;
		color: #f5f5f5;
		background: #f0f5ff;
		height: 80vh;

		.malltab {
			// margin-top: 30px;
			display: flex;
			height: 60px;
			background: #ffffff;
			box-shadow: -2px 7px 15px 0px #d2e0f7;
			border-top: 1px solid;
			border-bottom: 1px solid;

			border-image: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
			position: relative;
			.renBtn {
				position: absolute;
				top: 0;
				right: 15px;
				color: #888;
				line-height: 60px;
				font-size: 15px;
				cursor: pointer;
			}
			.malltab_item {
				width: 171px;
				// height: 59px;
				background: #fff;
				text-align: center;
				line-height: 59px;
				font-size: 18px;
				color: #000;
				cursor: pointer;
			}
			.check_item {
				color: #15418c;
				font-size: 20px;
				font-weight: 700;
				background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
			}
		}
		.mallfilke {
			margin-top: 50px;
			height: 60px;
			position: relative;
			.mallfilke_line {
				position: absolute;
				top: 25px;
				left: 0;
				height: 1px;
				width: 100%;
				background: linear-gradient(270deg, rgba(154, 82, 22, 0), rgba(154, 82, 22, 1), rgba(154, 82, 22, 0));
				// background: red;
			}
			.mallfilke_tab {
				margin: 0 10%;
				display: flex;
				height: 50px;
				line-height: 50px;
				.mallfilke_tabItem {
					cursor: pointer;
					// width: 150px;
					white-space: nowrap;
					padding: 0px 10px;
					line-height: 50px;
					background: #ffffff;
					border-radius: 30px;
					border: 1px solid #15418c;
					text-align: center;
					margin: 0 50px;
					font-family: MicrosoftYaHeiUI;
					font-size: 18px;
					color: #15418c;
					font-style: normal;
					z-index: 99;
				}
				.mallfilke_tabItemCheck {
					// background: #9a5216;
					// color: #fff;
					background: #15418c;
					color: #fff;
				}
			}
		}
		.dirFrame {
			margin-top: 40px;
			// height: 50vh;
			width: 100%;
			// background: red;
			color: #000;
			.dataMl {
			}
			.dataOrder {
				background: #ffffff;
				border-radius: 4px;
				border: 1px solid rgba(21, 65, 140, 0.2);
				min-height: 40vh;
				padding: 50px;
				.dotMsg {
					height: 50px;
					line-height: 50px;
					font-size: 22px;
					font-weight: 700;
					color: #000;
					padding-top: 80px;
					padding-left: 30px;
				}
			}
			.search_body {
				position: relative;
				//  min-height: 371px;
				background: #ffffff;
				border-radius: 4px;
				border: 1px solid rgba(21, 65, 140, 0.2);
				padding: 15px;
				padding-bottom: 40px;
				.search_title {
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 16px;
					color: #000000;
					font-weight: 700;
					display: flex;
					line-height: 16px;
					height: 30px;
					.line {
						width: 3px;
						margin-right: 5px;
						height: 14px;
						background: #9a5216;
					}
				}
				.search_cont {
					display: flex;
					flex-wrap: wrap;
					.search_item {
						min-width: 160px;
						height: 36px;
						line-height: 36px;
						text-align: center;
						cursor: pointer;
						// background: #9A5216;
						background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
						color: #15418c;
						border-radius: 4px;
						margin-right: 15px;
						padding: 0 15px;
						margin-bottom: 10px;
					}
					.search_itemCheck {
						// background: #9a5216;
						// color: #fff;
						background: #15418c;
						color: #fff;
					}
				}
			}
		}
	}
}
.operator_Btn {
	display: flex;
	justify-content: flex-end; /* 使子元素靠右 */
	gap: 10px; /* 元素间距 */
	text-align: right;
	font-size: 25px;
	margin-top: 15px;
	cursor: pointer;

	.item_CzBtn1 {
		// width: 88px;
		padding: 0px 10px;
		white-space: nowrap;
		height: 40px;
		// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
		background-repeat: no-repeat;
		// background-size: cover;
		background-size: 100% 100%;

		text-align: center;
		line-height: 40px;
		color: #fff;
		cursor: pointer;
		font-size: 14px;
		margin-bottom: 10px;
		background: #15418c;
	}

	.item_CzBtn2 {
		float: right;
		// margin-right: 15px;
		// width: 88px;
		white-space: nowrap;
		padding: 0px 10px;
		height: 40px;
		// background-image: url('../../assets/imgs/RemoteSensingMall/card2.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		text-align: center;
		line-height: 40px;
		// color: #cc7f3f;
		cursor: pointer;
		font-size: 14px;
		margin-bottom: 10px;
		background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
		color: #15418c;
	}
}
.SJbody {
	// margin-top: 25px;
}
.table_topdiv {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.select_all_control {
	// margin-bottom: 10px;
	.select_label {
		margin-left: 10px;
	}
}
.item_select {
	display: flex;
	// place-items: center;
	margin-right: 10px;
	margin-left: 10px;
	position: relative;
}

.pagediv {
	display: flex;
	justify-content: flex-end;
}
.bodyGird:after {
	content: ' ';
	width: 750px; //这个宽度和子元素宽度一致
	height: 0;
	display: block;
	margin-bottom: 15px;
}
.bodyGird {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	.dataItemGird {
		min-height: 200px;
		margin-bottom: 15px;
		width: 360px;
		// margin-right: 15px;
		background: #d7deed;
		.item_img {
			width: 350px;
			height: 196px;
			background: #000;
		}
		.item_label {
			margin-left: 15px;
		}
		.item_title {
			._title {
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 16px;
				color: #000000;
				text-align: left;
				line-height: 30px;
				width: 95%;
				word-break: break-all;
				font-weight: 700;
				cursor: pointer;
			}
			._btn {
				display: flex;
				flex: 1;
				justify-content: flex-end;
				.btnlist {
					background: #daa77f7b;
					margin-right: 15px;
					border-radius: 2px;
					font-family: MicrosoftYaHeiUISemibold;
					font-size: 14px;
					color: #cc7f3f;
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-style: normal;
					padding: 0px 8px;
				}
			}
		}
		.item_Cz {
			// display: flex;
			padding: 15px 0;
			.item_CzSl {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				.CzSl_list {
					display: flex;
					flex-wrap: wrap;

					width: 100%;
					.CzSl_listLabel {
						width: auto;
						height: 30px;

						font-family: MicrosoftYaHeiUI;
						font-size: 14px;
						color: #666666;
						text-align: left;
						font-style: normal;
					}
					.CzSl_listtext {
						font-family: MicrosoftYaHeiUI;
						font-size: 14px;
						// color: #cc7f3f;
						color: #15418c;
						text-align: left;
						font-style: normal;
						cursor: pointer;
					}
				}
			}
			.item_CzBtn {
				// width: 88px;
				white-space: nowrap;
				padding: 0px 10px;
				height: 67px;
				// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
				background-repeat: no-repeat;
				background-size: cover;
				text-align: center;
				line-height: 67px;
				color: #fff;
				cursor: pointer;

				background: #15418c;
			}
			.item_CzBtn1 {
				margin-right: 15px;
				// width: 88px;
				padding: 0px 10px;
				white-space: nowrap;
				height: 40px;
				// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
				background-repeat: no-repeat;
				// background-size: cover;
				background-size: 100% 100%;

				text-align: center;
				line-height: 40px;
				color: #fff;
				cursor: pointer;
				font-size: 14px;
				margin-bottom: 15px;

				background: #15418c;
			}
			.item_CzBtn2 {
				margin-right: 15px;
				// width: 88px;
				padding: 0px 10px;
				white-space: nowrap;
				height: 40px;
				// background-image: url('../../assets/imgs/RemoteSensingMall/card2.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				text-align: center;
				line-height: 40px;
				// color: #cc7f3f;
				cursor: pointer;
				font-size: 14px;
				margin-bottom: 15px;

				background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
				color: #15418c;
			}
		}
	}
}
.dataItem {
	display: flex;
	min-height: 200px;
	margin-bottom: 15px;
	.item_select {
		.checkboxClass {
			margin-right: 10px;
			// position: absolute;
			// right: 10px;
			// top: 10px;
		}
	}
	.item_img {
		width: 264px;
		height: 176px;
		background: #000;
	}
	.item_label {
		flex: 1;
		margin-left: 15px;
	}
	.item_title {
		display: flex;
		._title {
			width: 90%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-family: MicrosoftYaHeiUISemibold;
			font-size: 22px;
			color: #000000;
			text-align: left;
			height: 40px;
			// width: 70%;
			font-weight: 700;
		}
		._btn {
			display: flex;
			flex: 1;
			justify-content: flex-end;
			.btnlist {
				background: #daa77f7b;
				margin-right: 15px;
				border-radius: 2px;
				font-family: MicrosoftYaHeiUISemibold;
				font-size: 14px;
				color: #cc7f3f;
				height: 30px;
				line-height: 30px;
				text-align: center;
				font-style: normal;
				padding: 0px 8px;
			}
		}
	}
	.line {
		width: 100%;
		height: 1px;
		border: 1px solid #cc7f3f;
		opacity: 0.2;
		margin-bottom: 10px;
	}
	.item_desc {
		font-family: MicrosoftYaHeiUI;
		font-size: 16px;
		color: #333333;
		line-height: 25px;
		text-align: left;
		font-style: normal;
	}
	.item_Cz {
		display: flex;
		padding: 15px 0;
		.item_CzSl {
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			.CzSl_list {
				display: flex;
				width: 330px;
				align-items: baseline;
				.CzSl_listLabel {
					// width: 120px;
					height: 30px;

					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					color: #666666;
					text-align: left;
					font-style: normal;
				}
				.CzSl_listtext {
					font-family: MicrosoftYaHeiUI;
					font-size: 14px;
					// color: #cc7f3f;
					color: #15418c;
					text-align: left;
					font-style: normal;
					cursor: pointer;
					// margin-left: 10px;
				}
			}
		}
		.item_CzBtn {
			// width: 88px;
			padding: 0px 10px;
			white-space: nowrap;
			height: 67px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			background-size: cover;
			text-align: center;
			line-height: 67px;
			color: #fff;
			cursor: pointer;

			background: #15418c;
		}
		.item_CzBtn1 {
			margin-right: 15px;
			// width: 88px;
			white-space: nowrap;
			padding: 0px 10px;
			height: 40px;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card1.png');
			background-repeat: no-repeat;
			// background-size: cover;
			background-size: 100% 100%;

			text-align: center;
			line-height: 40px;
			color: #fff;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;

			background: #15418c;
		}
		.item_CzBtn2 {
			margin-right: 15px;
			// width: 88px;
			padding: 0px 10px;
			height: 40px;
			white-space: nowrap;
			// background-image: url('../../assets/imgs/RemoteSensingMall/card2.png');
			background-repeat: no-repeat;
			background-size: 100% 100%;
			text-align: center;
			line-height: 40px;
			color: #cc7f3f;
			cursor: pointer;
			font-size: 14px;
			margin-bottom: 15px;

			background: radial-gradient(208% 143% at 50% 0, rgba(21, 65, 140, 0.3) 0, rgba(21, 65, 140, 0) 100%);
			color: #15418c;
		}
	}
}
</style>
<style>
.dataOrder p img {
	width: 160px;
	float: left;
	height: auto;
}

.dataOrder p strong {
	display: block;
	margin: 10px 0;
	font-family: inherit;
	font-weight: bold;
	line-height: 20px;
	color: inherit;
	text-rendering: optimizelegibility;
	font-size: 18px;
	color: #222;
	text-align: center;
}
.dataOrder table {
	border-top: 1px solid #c46b16;
	border-left: 1px solid #c46b16;
	margin: 0 auto !important;
}
.dataOrder table td,
.dataOrder table th {
	padding: 0;
	margin: 0;
	/* padding: 3px 5px; */
	border-bottom: 1px solid #c46b16;
	border-right: 1px solid #c46b16;
}
.dataOrder table th {
	text-align: center;
}

.dataOrder table th {
	font-weight: 700;
	text-align: center;
	background-color: #c46b16 !important;
	height: 60px;
	line-height: 60px;
	/* border-right: 1px solid #efb277; */
	color: #fff;
}
/* .dataOrder table td, */
.dataOrder table td {
	/* font-weight: 700; */
	/* background-color: #c46b16 !important; */
	/* color: #fff; */
	/* border: 1px solid #efb277; */
	line-height: 32px !important;
	text-align: center !important;
	padding: 0 20px;
	vertical-align: inherit;
}
.dataOrder .table td {
	/* border: 1px solid #efb277 !important; */
	line-height: 32px !important;
	text-align: center !important;
	padding: 0 20px;
	vertical-align: inherit;
}
</style>